import { EColorVariablesV2, IColorVariants, PANEL_THEME_COLOR_CONTENT_MAP } from '@/types/theme-packs.types';
import Container from '@ui/container/container';

type TThemeInfoPillColorsProps = {
  themeColors?: IColorVariants;
  backgroundDimensions?: { height?: string; width?: string };
  accentDimensions?: { height?: string; width?: string };
};

const primaryMeta = PANEL_THEME_COLOR_CONTENT_MAP[EColorVariablesV2.primary];
const accentMeta = PANEL_THEME_COLOR_CONTENT_MAP[EColorVariablesV2.accents];

const ThemeInfoPillColors = ({
  themeColors,
  backgroundDimensions = {
    height: '20px',
    width: '40px',
  },
  accentDimensions = {
    height: '20px',
    width: '20px',
  },
}: TThemeInfoPillColorsProps) => {
  const primaryColor = themeColors?.[primaryMeta?.mappedV1Value];
  const accentColor = themeColors?.[accentMeta?.mappedV1Value];
  return (
    <div className="flex fd-row jc-flex-start ai-center gap-4">
      <Container
        borderWidth="1px"
        borderStyle="solid"
        borderColor="rgb(var(--gray-100-rgb), 0.1)"
        borderRadius="4px"
        background={primaryColor}
        height={backgroundDimensions?.height || '20px'}
        width={backgroundDimensions?.width || '40px'}
        skeletonLoader={!primaryColor}
      />

      <Container
        borderWidth="1px"
        borderStyle="solid"
        borderColor="rgb(var(--gray-100-rgb), 0.1)"
        borderRadius="4px"
        background={accentColor}
        height={accentDimensions?.height || '20px'}
        width={accentDimensions?.width || '20px'}
        skeletonLoader={!accentColor}
      />
    </div>
  );
};

export default ThemeInfoPillColors;
